import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
@Component({
  selector: 'app-customvariable',
  templateUrl: './customvariable.component.html',
  styleUrls: ['./customvariable.component.css']
})
export class CustomvariableComponent implements OnInit {

  public form: FormBuilder;

  currentState: number;
  public lead_field: string = '-1';
  campaign: any;
  crm_label: any = [];
  labData: any;
  newData: any;
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialogRef: MatDialogRef<CustomvariableComponent>, protected router: Router, protected msg: MatSnackBar, protected fb: FormBuilder) {
    console.log(data);
  }

  ngOnInit() {
    this.labData = this.data.crm_lbel
    console.log(this.labData);
    
    // var dataa = this.labData.map(t => t.label);
    this.campaign = this.data.campaign

    for (let index = 0; index < this.labData.length; index++) {
      if (this.labData[index].label == "") {
        continue;
      }
      this.newData = { fields: this.labData[index].fields, label: this.labData[index].label, default: this.labData[index].default };
      this.crm_label.push(this.newData)
      console.log("this.crm_label",this.crm_label);

    }

  }

  agentfields = [{ fields: "agent_firstname", label: "Agent First Name" },{ fields: "agent_lastname", label: "Agent Last Name" },{ fields: "agent_fullname", label: "Agent Fullname" }, { fields: "agent_contact", label: "Agent Contact" }, { fields: "agent_email", label: "Agent Email" }];

  othersfields = [{ fields: "appointment_comments", label: "Appointment Comments" }, { fields: "appointment_date", label: "Appointment Date" }, { fields: "appointment_place", label: "Appointment Place" }, { fields: "appointment_start_time", label: "Appointment Start Time" }, { fields: "appointment_end_time", label: "Appointment End Time" }, { fields: "zoom", label: "ZOOM URL" }, {fields: "reschedule_appointment", label:"Reschedule Appointment"}, {fields:"cancel" , label: "Cancel"}];



  questionfields: any = [
    { fields: "uscitizon", label: "Us Citizen" },
    { fields: "worktimezone", label: "Working Time Zone" },
    { fields: "isfelony", label: "Felony" },
    { fields: "previousemployment", label: "Previous Employment Description" },
    { fields: "mostlike", label: "Previous Employment Most Like" },
    { fields: "leastlike", label: "Previous Employment Least Like" },
    { fields: "income", label: "Income" }
  ]

  updateleadscript() {
    console.log(this.lead_field);
    this.leadclose({ leadType: this.lead_field });
  }


  leadclose(sdata: any) {
    this.dialogRef.close(sdata);
    console.log(sdata);
  }

  onDisable(event) {
    console.log(event);
    this.currentState = event;
  }

  Close() {
    this.dialogRef.close();
    console.log("close");
  }


}
